<script>
	import Select, { Option } from "@smui/select";

	import { projects, selectedProject, selectedProjectObj, setupComplete } from "../stores";
</script>

{#if $setupComplete}
	<div class="main-select project-selection" class:hide={!$selectedProject}>
		<Select bind:value={$selectedProject} variant="outlined" label="Project" disabled={$projects.length <= 1}>
			{#each $projects as p}
				<Option value={p.project_id}>{p.name}</Option>
			{/each}
		</Select>
	</div>
{/if}

<style lang="scss">
	.hide {
		transition: opacity 0.3s ease;
		opacity: 0;
	}

	.project-selection {
		width: 270px;

		:global(.mdc-select) {
			width: 100%;
		}

		:global(.mdc-select--disabled .mdc-select__dropdown-icon) {
			transition: opacity 0.3s ease;
			opacity: 0;
		}

		:global(.mdc-deprecated-list-item) {
			white-space: nowrap;
			width: 100%;
			box-sizing: border-box;
		}

		:global(.mdc-select__menu.mdc-menu-surface--open) {
			width: fit-content;
		}
	}
</style>
